import { Paper, Stack, Typography } from "@mui/material";
import type { DropInPricePresentation } from "../dropInPricePresentation";

export function DropInOrderSummary({
  facilityName,
  playerName,
  priceLabel,
  paymentLabel,
  price,
}: {
  facilityName: string;
  playerName: string;
  priceLabel: string;
  paymentLabel?: string;
  price: DropInPricePresentation;
}) {
  return (
    <Paper
      component="section"
      variant="outlined"
      aria-label="Order summary"
      sx={{ p: 2 }}
    >
      <Typography component="h2" variant="h6">
        Drop-in details
      </Typography>
      <Stack component="dl" spacing={1} sx={{ m: 0, mt: 1.5 }}>
        <OrderRow label="Facility" value={facilityName} />
        <OrderRow label="Player" value={playerName} />
        {paymentLabel ? (
          <OrderRow label="Payment" value={paymentLabel} />
        ) : null}
        {price.campaignName ? (
          <OrderRow label="Special" value={price.campaignName} />
        ) : null}
        {price.original ? (
          <OrderRow label="Original price" value={price.original} />
        ) : null}
      {price.savingsLabel ? (
        <OrderRow label="You save" value={`−${price.savingsLabel}`} />
        ) : null}
        <OrderRow label="Total" value={priceLabel} emphasized />
      </Stack>
    </Paper>
  );
}

function OrderRow({
  label,
  value,
  emphasized = false,
}: {
  label: string;
  value: string;
  emphasized?: boolean;
}) {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ justifyContent: "space-between", alignItems: "baseline" }}
    >
      <Typography component="dt" color="text.secondary">
        {label}
      </Typography>
      <Typography
        component="dd"
        sx={{ m: 0, textAlign: "right", fontWeight: emphasized ? 800 : 600 }}
      >
        {value}
      </Typography>
    </Stack>
  );
}
